import type React from "react";

export enum AvatarType {
  Author = "author",
  User = "user",
}

export interface IAvatarContainer {
  contentBottom?: null | undefined | string | JSX.Element;
  contentTop?: null | undefined | string | JSX.Element;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  imgAnchor?: string;
  /** версия дизайна */
  e2eId?: string;
  tabIndex?: number;
}

export interface IAvatarImg {
  id: number;
  imgClassName?: string;
  containerSize?: number;
  hasAvatar?: boolean;
  hash?: string;
  imageURL?: string | null;
  loading?: HTMLImageElement["loading"];
  alt?: HTMLImageElement["alt"];
  decoding?: HTMLImageElement["decoding"];
  /** Привести ссылку к виду без размера, например, https://cdn.litres.ru/pub/authors/100/00/04/50/00045097.jpg */
  removeSizeFromImgUrl?: boolean;
}

export interface IAvatarAuthor extends IAvatarImg {
  size: 50 | 100;
  type: AvatarType.Author;
}
export interface IAvatarUser extends IAvatarImg {
  size: 30 | 40 | 50 | 68 | 500;
  type: AvatarType.User;
}

export type TAvatarProps = (IAvatarUser | IAvatarAuthor) & IAvatarContainer;
